import Modal from '@/components/common/modal';
import CreateForm from './create.form';
import { useTranslations } from '@/i18n/use-translations';

interface CreateOrganizationModalProps {
  open: boolean;
  onClose: () => void;
  /** Called when organization is created successfully. The modal will close after this. */
  onSuccess: () => void;
}

export default function CreateOrganizationModal({ open, onClose, onSuccess }: CreateOrganizationModalProps) {
  const t = useTranslations();

  const handleSuccess = () => {
    onSuccess();
    onClose();
  };

  return (
    <Modal
      open={open}
      size="sm"
      handleClose={onClose}
      title={t('organization.createNewTitle')}
      description={t('organization.createNewDescription')}
    >
      <CreateForm onCancel={onClose} onSuccess={handleSuccess} />
    </Modal>
  );
}
